// Localized lookup for conference / division names stored in league data.
// The underlying value (e.g. "Eastern Conference", "Atlantic") may come from
// DEFAULT_CONFS / DEFAULT_DIVS or be user-entered. We translate known English
// defaults; anything else (custom user names) passes through unchanged.
import i18n from "./i18n.ts";

export const translateConfName = (name: string): string => {
	if (!i18n.isInitialized) return name;
	const t = i18n.t(`conference.${name}`, { ns: "ui", defaultValue: name });
	return typeof t === "string" && t.length > 0 ? t : name;
};

export const translateDivName = (name: string): string => {
	if (!i18n.isInitialized) return name;
	const t = i18n.t(`division.${name}`, { ns: "ui", defaultValue: name });
	return typeof t === "string" && t.length > 0 ? t : name;
};
